import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["message"]

  connect() {
    // Auto-dismiss after 5 seconds
    this.messageTargets.forEach((message) => {
      setTimeout(() => {
        this.dismissMessage(message)
      }, 5000)
    })
  }

  dismiss(event) {
    const message = event.target.closest("[data-flash-target='message']")
    this.dismissMessage(message)
  }

  dismissMessage(message) {
    if (message) {
      message.classList.add("animate-fade-out")
      setTimeout(() => {
        message.remove()
      }, 300)
    }
  }

  remove(event) {
    if (event.animationName === "fadeOut") {
      event.target.remove()
    }
  }
}
